<template>
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'GlobalErrorHandler',
  mounted() {
    // Global error handler for unhandled promise rejections
    window.addEventListener('unhandledrejection', this.handleUnhandledError)
    
    // Global error handler for uncaught errors
    window.addEventListener('error', this.handleGlobalError)
  },
  
  beforeUnmount() {
    window.removeEventListener('unhandledrejection', this.handleUnhandledError)
    window.removeEventListener('error', this.handleGlobalError)
  },
  
  methods: {
    handleUnhandledError(event) {
      console.error('🚨 Unhandled promise rejection:', event.reason)
      
      // Check if it's an authentication error
      if (event.reason?.response?.status === 401) {
        this.handleAuthError(event.reason)
      } else if (event.reason?.response?.status === 403) {
        this.handleForbiddenError(event.reason)
      } else if (event.reason?.response?.status === 500) {
        this.handleServerError(event.reason)
      }
      
      // Prevent the default browser error handling
      event.preventDefault()
    },
    
    handleGlobalError(event) {
      console.error('🚨 Global error:', event.error)
      
      // Check if it's an authentication-related error
      if (event.error?.message?.includes('auth') || 
          event.error?.message?.includes('token') ||
          event.error?.message?.includes('unauthorized')) {
        this.handleAuthError(event.error)
      }
    },
    
    handleAuthError(error) {
      console.log('🔒 Global auth error handler:', error)
      
      // No authentication required - just log the error
      console.log('ℹ️ Authentication error - no redirect needed')
    },
    
    handleForbiddenError(error) {
      console.log('🚫 Global forbidden error handler:', error)
      
      // No authentication required - just log the error
      console.log('ℹ️ Forbidden error - no redirect needed')
    },
    
    handleServerError(error) {
      console.log('❌ Global server error handler:', error)
      // Don't redirect for server errors, just log them
    }
  }
}
</script>
